import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import BaseDetails from 'containers/Base/BaseDetails';
import { toggleModal } from 'reducers/ui';
import staticText from 'static/text_display.json';
import {
  translatedKeyValueText,
  languageConverter,
} from 'utils/methods/helpers';
import { PAGE_NAME } from 'utils/constants';
import isEmpty from 'lodash/isEmpty';
import { t } from 'i18next';

import { actions as dataGridTableActions } from '../Modules/dataGridTable';
import * as templateSelectors from '../Selectors/templateSelectors';

const CleanerDetails = ({
  id,
  cancel,
  toggleEditMode,
  toggleModal,
  editable,
  details,
  fetchTemplateTaskDetails,
  fetchTemplateTaskDetailsPdf,
  operationComponent: Operational,
  downloadable,
  rawDetails,
  checkCanBeEdited,
  selected,
  setMessage,
  resetMsg,
}) => {
  const [isEditable, setIsEditable] = useState(editable);
  const loading = useSelector(state => state.ui.loading);

  const onDownloadClick = () => {
    fetchTemplateTaskDetailsPdf({ id });
  };

  useEffect(() => {
    if (id && selected) {
      fetchTemplateTaskDetails(id, selected);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (typeof checkCanBeEdited === 'function' && !isEmpty(details)) {
      setIsEditable(checkCanBeEdited({ data: details }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!isEmpty(details) && details.others.id.value]);

  const onEdit = () => {
    toggleEditMode();
    toggleModal();
    typeof resetMsg === 'function' && resetMsg();
  };
  const languageConvertedTaskDetails = details => {
    return languageConverter({
      details,
      arrayOfKeys: ['taskType', 'status'],
    });
  };
  return (
    <BaseDetails
      editable={isEditable}
      header={staticText.cleaner_operational_view.task.details}
      details={languageConvertedTaskDetails(details)}
      onEdit={onEdit}
      cancel={cancel}
      loading={loading}
      {...(Operational && {
        operationComponent: (
          <Operational
            details={details}
            id={id}
            toggleModal={toggleModal}
            toggleEditMode={toggleEditMode}
            setMessage={setMessage}
            rawDetails={rawDetails}
            selected={selected}
          />
        ),
      })}
      editHoverText={
        details && Object.keys(details).length > 0
          ? translatedKeyValueText('edit_value_title', {
              value: details.generalInfo.taskName.value,
            })
          : t(staticText.cleaner_operational_view.task.details)
      }
      downloadable={downloadable}
      {...(downloadable && {
        onDownloadClick: onDownloadClick,
        downloadHoverText: staticText.reporting_view.task_download,
      })}
    />
  );
};

const mapStateToProps = state => ({
  details: templateSelectors.getGridRowDetailsTransformed(state),
  rawDetails: templateSelectors.getDetailsTransformedRaw(state),
});

const mapDispatchToProps = dispatch => ({
  fetchTemplateTaskDetails: (id, dummyTaskData) =>
    dispatch(dataGridTableActions.fetchGridRowDetails({ id, dummyTaskData })),
  fetchTemplateTaskDetailsPdf: ({ id }) =>
    dispatch(dataGridTableActions.fetchGridRowDetailsPdf({ id })),
  toggleModal: () => dispatch(toggleModal(PAGE_NAME.TEMPLATE_TASKS)),
});

CleanerDetails.propTypes = {
  id: PropTypes.string,
  cancel: PropTypes.func,
  toggleEditMode: PropTypes.func,
  toggleModal: PropTypes.func,
  editable: PropTypes.bool,
  details: PropTypes.object,
  fetchTemplateTaskDetails: PropTypes.func,
  fetchTemplateTaskDetailsPdf: PropTypes.func,
  fetchTemplateTaskQr: PropTypes.func,
  operationComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  downloadable: PropTypes.bool,
  onDownloadClick: PropTypes.func,
  rawDetails: PropTypes.object,
  checkCanBeEdited: PropTypes.func,
  selected: PropTypes.object,
  setMessage: PropTypes.func,
  resetMsg: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(CleanerDetails);
